import React from 'react';
import { FormattedMessage } from "react-intl";
import './Eingabe.css';

class EingabeAnzahlKulissen extends React.Component {
   constructor(props) {
    super(props);
    this.state = {
        value: '1',
        minKulissen: 1,
        maxKulissen: 1,
        options : [],
        exampleArray: [],
    };

    this.handleInputChange= this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProp, prevState, snapshot) {

       if(prevProp.kulissenbreite !== this.props.kulissenbreite || prevProp.kanalbreite !== this.props.kanalbreite){
           this.props.SelectedKulissenanzahl(this.getMinKulissen());
       }

  }


    handleInputChange(event) {
    const target = event.target;
    const value = target.name === 'isGoing' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value    });
  }
  handleSubmit(event) {
    alert('Kanalbreite: ' + this.state.kanalbreite + '\r' +
        'Volumenstrom: ' +this.state.volumenstrom);
    event.preventDefault();
  }
  getMinKulissen(){
    // console.log('Kulissenbreite' + this.props.kulissenbreite);
    // console.log('Kanalbreite' + this.props.kanalbreite);
    //let minDS = 20;
    let maxDS = 350;
    // let kanalbreite: number = this.eingabe?.kanalbreite;
    this.minAnzahlkulissen = Math.ceil(((parseInt(this.props.kanalbreite)) / (parseInt(maxDS) + parseInt(this.props.kulissenbreite))));
    // console.log('MinKulissen: ' + this.minAnzahlkulissen);
    if (this.minAnzahlkulissen <= 1){
      this.minAnzahlkulissen = 1;
    }
    // console.log('MinKulissen: ' + this.minAnzahlkulissen);

    return this.minAnzahlkulissen;

  }
  getMaxKulissen = () =>{

    let minDS = 20;

    this.maxAnzahlkulissen = Math.trunc(((parseInt(this.props.kanalbreite))) / ( minDS + parseInt(this.props.kulissenbreite)));

      // console.log("maxKulissen: "+ this.maxAnzahlkulissen + ", minKulissen: " + this.minAnzahlkulissen);
    return this.maxAnzahlkulissen;
  }

  createOptions = () =>{
       let opt = [];
       let maxKulissen = this.getMaxKulissen();
       if(maxKulissen > 33)
       {
           maxKulissen = 33;
       }

       for (let i = this.getMinKulissen(); i < maxKulissen+1; i++) {
            opt.push(<option key={i} value={i}>{i}</option>);
        };
       return opt;
  }

  handleChange(event) {

        this.props.SelectedKulissenanzahl(event.target.value);
  }


  render() {

    return (
        <div>
          <label> <FormattedMessage id='Kulissenanzahl' /></label>
              <select value={this.props.value} onChange={this.handleChange}>
                  {this.createOptions()}
              </select>
              <span hidden={this.maxAnzahlkulissen <= 33}>Max. Anzahl auf 33 Kulissen begrenzt</span>


        </div>
    );
  }
}
export default EingabeAnzahlKulissen;
